// extracted by mini-css-extract-plugin
export default {"root":"Loading-module__root___CQxHe","message":"Loading-module__message___DId02","icon":"Loading-module__icon___IzX_v","cycle":"Loading-module__cycle___rHrwp"};